var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Multiselect',_vm._b({attrs:{"value":_vm.spaceId,"options":_vm.spaceOptions,"clearable":false,"disabled":_vm.loading || _vm.$attrs.disabled,"track-by":"value","label":"text"},on:{"inputTrackBy":function($event){_vm.spaceId = $event}}},'Multiselect',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }